import type { TUIElement } from '@ballerine/common';

import { useEvents } from '../useEvents';
import { useUnmount } from '../useUnmount';

export const useUnmountEvent = (element: TUIElement) => {
  const { sendEvent } = useEvents(element);

  useUnmount(() => sendEvent('onUnmount'));
};
